export function useAdminNavigation() {
  const goBack = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return { goBack };
}
